import { useEffect } from 'react';
import { useHistory } from 'react-router';

import type { MicroFrontend } from '../../../../../shared/types/microFrontend.types';
import dash_api from '../../support/dash_api';

const TIMEOUT_DELAY_DURATION = 30000 as const;

const updatePrometheusTimeoutCounter = async (microFrontend: MicroFrontend) => {
  try {
    await dash_api.post(`/v1/micro-frontends/analytics/timeouts/${microFrontend}`);
  } catch (error) {
    throw error;
  }
};

export const useMicroFrontendTimeout = (isMicroFrontendReady: boolean, microFrontend: MicroFrontend): void => {
  const history = useHistory();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isMicroFrontendReady) {
        history.push('/out-of-service');

        updatePrometheusTimeoutCounter(microFrontend);
      }
    }, TIMEOUT_DELAY_DURATION);

    return () => {
      clearTimeout(timer);
    };
  }, [isMicroFrontendReady, microFrontend, history]);
};
